import { render, staticRenderFns } from "./GerenciamentoLoginSocial.vue?vue&type=template&id=352ea5b5&scoped=true"
import script from "./GerenciamentoLoginSocial.vue?vue&type=script&lang=js"
export * from "./GerenciamentoLoginSocial.vue?vue&type=script&lang=js"
import style0 from "./GerenciamentoLoginSocial.vue?vue&type=style&index=0&id=352ea5b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352ea5b5",
  null
  
)

export default component.exports